/**
 * Video URL helpers for GCS and other sources.
 * storage.cloud.google.com often has CORS/access issues in HTML5 video;
 * we can try storage.googleapis.com or show a fallback message.
 */

export function isGcsStorageUrl(url: string | undefined | null): boolean {
  if (!url || typeof url !== 'string') return false;
  return url.includes('storage.cloud.google.com');
}

/**
 * Convert storage.cloud.google.com to storage.googleapis.com for better playback compatibility.
 * Example: https://storage.cloud.google.com/bucket/path/file.mp4
 *       -> https://storage.googleapis.com/bucket/path/file.mp4
 */
export function toStorageGoogleapisUrl(url: string): string {
  if (!url.includes('storage.cloud.google.com')) return url;
  return url.replace('storage.cloud.google.com', 'storage.googleapis.com');
}

export function getVideoDisplayUrl(url: string | undefined | null): string {
  if (!url) return '';
  if (isGcsStorageUrl(url)) return toStorageGoogleapisUrl(url);
  return url;
}
